import { font, breakpoints, colors } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": {
      renderFantaStyles: false
    },
    fanta: {
      renderFantaStyles: true
    },
    prop: themeProp
  };
};

var H1Styles = function H1Styles(_ref) {
  var renderFantaStyles = _ref.customTheme.renderFantaStyles,
      _ref$variantType = _ref.variantType,
      variantType = _ref$variantType === void 0 ? 'heavy' : _ref$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px32, ";\n    font-weight: ").concat(font.weight.heavy, ";\n    line-height: ").concat(font.lineHeight.md, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px36, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px42, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px48, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px36, ";\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.1;\n    letter-spacing: 0.35px;\n  "));
};

var H2Styles = function H2Styles(_ref2) {
  var renderFantaStyles = _ref2.customTheme.renderFantaStyles,
      _ref2$variantType = _ref2.variantType,
      variantType = _ref2$variantType === void 0 ? 'heavy' : _ref2$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px28, ";\n    font-weight: ").concat(font.weight.heavy, ";\n    line-height: ").concat(font.lineHeight.md, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px30, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px32, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px36, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px32, ";\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.1;\n    letter-spacing: 0.35px;\n  "));
};

var H3Styles = function H3Styles(_ref3) {
  var renderFantaStyles = _ref3.customTheme.renderFantaStyles,
      _ref3$variantType = _ref3.variantType,
      variantType = _ref3$variantType === void 0 ? 'heavy' : _ref3$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px24, ";\n    font-weight: ").concat(font.weight.normal, ";\n    line-height: ").concat(font.lineHeight.lg, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px28, ";\n      font-weight: ").concat(font.weight.heavy, ";\n      line-height: ").concat(font.lineHeight.md, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px30, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px32, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px28, ";\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.3;\n    letter-spacing: 0.35px;\n  "));
};

var H4Styles = function H4Styles(_ref4) {
  var renderFantaStyles = _ref4.customTheme.renderFantaStyles,
      _ref4$variantType = _ref4.variantType,
      variantType = _ref4$variantType === void 0 ? 'normal' : _ref4$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px16, ";\n    font-weight: ").concat(font.weight.normal, ";\n    line-height: ").concat(font.lineHeight.lg, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px18, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px20, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px24, ";\n    }\n  ") : "\n    font-size: ".concat(26 / 16, "rem;\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.3;\n    letter-spacing: 0;\n  "));
};

var H5Styles = function H5Styles(_ref5) {
  var renderFantaStyles = _ref5.customTheme.renderFantaStyles,
      _ref5$variantType = _ref5.variantType,
      variantType = _ref5$variantType === void 0 ? 'normal' : _ref5$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px22, ";\n    font-weight: ").concat(font.weight.normal, ";\n    line-height: ").concat(font.lineHeight.lg, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px22, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px22, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px22, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px22, ";\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.3;\n    letter-spacing: 0;\n  "));
};

var H6Styles = function H6Styles(_ref6) {
  var renderFantaStyles = _ref6.customTheme.renderFantaStyles,
      _ref6$variantType = _ref6.variantType,
      variantType = _ref6$variantType === void 0 ? 'normal' : _ref6$variantType;
  return css(["", ""], renderFantaStyles ? "\n    font-size: ".concat(font.size.px18, ";\n    font-weight: ").concat(font.weight.normal, ";\n    line-height: ").concat(font.lineHeight.lg, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px18, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px18, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px18, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px20, ";\n    font-weight: ").concat(font.weight[variantType], ";\n    line-height: 1.3;\n    letter-spacing: 0.25px;\n  "));
};

var SubtitleStyles = function SubtitleStyles(_ref7) {
  var _ref7$variantType = _ref7.variantType,
      variantType = _ref7$variantType === void 0 ? 'normal' : _ref7$variantType;
  return css(["font-size:", ";font-weight:", ";line-height:1.3;letter-spacing:0;"], font.size.px18, font.weight[variantType]);
};

var Body1Styles = function Body1Styles(_ref8) {
  var renderFantaStyles = _ref8.customTheme.renderFantaStyles,
      _ref8$variantType = _ref8.variantType,
      variantType = _ref8$variantType === void 0 ? 'normal' : _ref8$variantType;
  return css(["", ""], renderFantaStyles && variantType === 'paragraph' ? "\n    font-size: ".concat(font.size.px16, ";\n    font-weight: ").concat(font.weight.normal, ";\n    line-height: ").concat(font.lineHeight.lg, ";\n    @media (min-width: ").concat(breakpoints.md.min, ") {\n      font-size: ").concat(font.size.px16, ";\n    }\n    @media (min-width: ").concat(breakpoints.lg.min, ") {\n      font-size: ").concat(font.size.px16, ";\n    }\n    @media (min-width: ").concat(breakpoints.xl.min, ") {\n      font-size: ").concat(font.size.px16, ";\n    }\n  ") : "\n    font-size: ".concat(font.size.px16, ";\n    font-weight: ").concat(font.weight[variantType === 'paragraph' ? 'normal' : variantType], ";\n    line-height: ").concat(variantType === 'paragraph' ? 1.5 : 1.3, ";\n    letter-spacing: 0.25px;\n  "));
};

var Body2Styles = function Body2Styles(_ref9) {
  var _ref9$variantType = _ref9.variantType,
      variantType = _ref9$variantType === void 0 ? 'normal' : _ref9$variantType;
  return css(["font-size:", ";font-weight:", ";line-height:", ";letter-spacing:0.25px;"], font.size.px14, font.weight[variantType === 'paragraph' ? 'normal' : variantType], variantType === 'paragraph' ? 1.5 : 1.3);
};

var CaptionStyles = function CaptionStyles(_ref10) {
  var _ref10$variantType = _ref10.variantType,
      variantType = _ref10$variantType === void 0 ? 'normal' : _ref10$variantType;
  return css(["font-size:", ";font-weight:", ";line-height:1.3;letter-spacing:0.35px;"], font.size.px12, font.weight[variantType]);
};

var OverlineStyles = function OverlineStyles(_ref11) {
  var _ref11$variantType = _ref11.variantType,
      variantType = _ref11$variantType === void 0 ? 'xs' : _ref11$variantType;
  return css(["font-size:", ";font-weight:", ";letter-spacing:", ";line-height:1.1;text-transform:uppercase;"], variantType === 'xs' ? font.size.px12 : font.size.px18, variantType === 'xs' ? font.weight['bold'] : font.weight['medium'], variantType === 'xs' ? '1.25px' : '1px');
};

var getButtonFontSize = function getButtonFontSize(variantType) {
  switch (variantType) {
    case 'xs':
      return font.size.px12;

    case 'sm':
      return font.size.px14;

    case 'md':
      return font.size.px16;

    default:
      return font.size.px20;
  }
};

var getButtonFontWeight = function getButtonFontWeight(variantType) {
  switch (variantType) {
    case 'xs':
    case 'sm':
    case 'md':
      return font.weight.medium;

    default:
      return font.weight.bold;
  }
};

var ButtonStyles = function ButtonStyles(_ref12) {
  var _ref12$variantType = _ref12.variantType,
      variantType = _ref12$variantType === void 0 ? 'lg' : _ref12$variantType,
      underline = _ref12.underline;
  return css(["font-size:", ";font-weight:", ";line-height:1.3;letter-spacing:0.25px;text-decoration:", ";"], getButtonFontSize(variantType), getButtonFontWeight(variantType), underline ? 'underline' : 'none');
};

var getDisplayFontSize = function getDisplayFontSize(variantType) {
  switch (variantType) {
    case 'display1':
      return "".concat(74 / 16, "rem");

    case 'display2':
      return "".concat(66 / 16, "rem");

    case 'display3':
      return font.size.px52;

    case 'display4':
      return "".concat(46 / 16, "rem");

    case 'display5':
    default:
      return font.size.px42;
  }
};

var getDisplayLineHeight = function getDisplayLineHeight(variantType) {
  switch (variantType) {
    case 'display1':
    case 'display2':
    case 'display3':
      return '-0.75px';

    case 'display4':
    case 'display5':
    default:
      return '0.35px';
  }
};

var DisplayStyles = function DisplayStyles(_ref13) {
  var variant = _ref13.variant;
  return css(["font-size:", ";font-weight:", ";letter-spacing:", ";line-height:1.1;"], getDisplayFontSize(variant), variant === 'display6' ? font.weight.bold : font.weight.heavy, getDisplayLineHeight(variant));
};

export var TypographyContainer = styled.div.withConfig({
  componentId: "sc-1b146w8-0"
})(["position:relative;margin:0;font-family:", ";", " ", " ", ""], font.family["default"], function (_ref14) {
  var enableTextShadow = _ref14.enableTextShadow,
      textContent = _ref14.textContent,
      textShadowMixBlendMode = _ref14.textShadowMixBlendMode;
  return enableTextShadow ? css(["", ""], textShadowMixBlendMode ? "\n        &:before{\n          content: '".concat(textContent, "';\n          color: ").concat(colors.transparent, ";\n          z-index: -1;\n          position: absolute;\n          left: 0;\n          top: 0;\n          width: 100%;\n          text-shadow: 0 0 0.5em ").concat(colors.dark, ";\n          mix-blend-mode: ").concat(textShadowMixBlendMode, ";\n        }\n      ") : css(["text-shadow:0 0 0.5em ", ";"], colors.dark)) : undefined;
}, function (_ref15) {
  var display = _ref15.display;
  return display ? css(["display:", ";"], display) : undefined;
}, function (props) {
  switch (props.variant) {
    case 'h1':
      return H1Styles(props);

    case 'h2':
      return H2Styles(props);

    case 'h3':
      return H3Styles(props);

    case 'h4':
      return H4Styles(props);

    case 'h5':
      return H5Styles(props);

    case 'h6':
      return H6Styles(props);

    case 'subtitle':
      return SubtitleStyles(props);

    case 'body1':
      return Body1Styles(props);

    case 'body2':
      return Body2Styles(props);

    case 'caption':
      return CaptionStyles(props);

    case 'overline':
      return OverlineStyles(props);

    case 'button':
      return ButtonStyles(props);

    case 'display1':
    case 'display2':
    case 'display3':
    case 'display4':
    case 'display5':
    case 'display6':
      return DisplayStyles(props);
  }
});